import React from "react";
import { connect } from "react-redux";
import shortid from "shortid";
import { withRouter } from "react-router-dom";

const ReactDOMServer = require("react-dom/server");
const HtmlToReactParser = require("html-to-react").Parser;

const openInNewTab = (href) => {
  Object.assign(document.createElement("a"), {
    target: "_blank",
    href,
    rel: "noopener noreferrer",
  }).click();
};

const SoftwareAward = (props) => {
  const getBadgeSVG = (award, id) => {
    const badgeHTML = award.svg_badge;
    const htmlToReactParser = new HtmlToReactParser();
    const reactElement = htmlToReactParser.parse(badgeHTML);
    const reactHtml = ReactDOMServer.renderToStaticMarkup(reactElement);
    document.getElementById(id).innerHTML = reactHtml;
  };

  const AwardReferenceLinks = (details) => {
    return (
      <>
        <div className="footer_block">
          {!!details.press_release_url ? (
            <span className="press_release">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  openInNewTab(details.press_release_url);
                }}
              >
                Press Release
              </a>
            </span>
          ) : null}
          <span className="report">
            {!!details.link ? (
              <a
                href="#"
                onClick={(e) => {
                  //open in new tab
                  e.preventDefault();
                  if (details.show_landing_page) {
                    props.history.push(
                      `/vendor/${props.match.params.id}${details.link
                        .replace("/api/v1", "")
                        .replace(
                          "/customers-success-report",
                          "/customer-success-report"
                        )}`
                    );
                  } else {
                    openInNewTab(
                      `${process.env.REACT_APP_API_URL}${details.link.replace(
                        "/api/v1",
                        ""
                      )}`
                    );
                  }
                }}
              >
                Report
              </a>
            ) : null}
          </span>
        </div>
      </>
    );
  };

  const composeText = (details) => {
    return (
      <React.Fragment>
        <div className="text_block">
          <span className="year">{`${details?.season} ${details?.year}`}</span>
          <span className="award_name">
            {details?.type === "award"
              ? `${details?.classification} Award`
              : `${details?.classification}`}
          </span>
          <span className="type">{`${details?.category_label}`}</span>
          {details?.type === "report" ? (
            <AwardReferenceLinks {...details} />
          ) : null}
        </div>
      </React.Fragment>
    );
  };

  const composeTextMomentum = (details) => {
    if (!!details.category_label) {
      return composeText(details);
    } else {
      return (
        <React.Fragment>
          <span className="year">{`${details.season} ${details.year}`}</span>
          <span className="name">{`Momentum Award`}</span>

          {details.type === "report" ? (
            <AwardReferenceLinks {...details} />
          ) : null}
        </React.Fragment>
      );
    }
  };

  const getAwardDescription = (award) => {
    switch (award.classification.toLowerCase()) {
      // case 'market leader':
      // case 'top performer':
      // case 'rising star':
      // case 'best in category':
      // case 'most popular':
      // case 'local leader':
      // case 'customer excellence':
      // case 'hot 100 vendor':
      // case 'momentum leader':
      // case 'top rated software':
      // case 'up-and-coming vendor':

      case "momentum":
        return composeTextMomentum(award);
      default:
        return composeText(award);
    }
  };

  const hideShowContent = (event) => {
    event.preventDefault();
    const hiddenItems = Array.prototype.slice.call(
      document.querySelectorAll(".awardHide")
    );
    console.log("hiddenItems >> ", hiddenItems);

    const button = document.querySelector(".showLessMoreAward");
    const showing = button.textContent === "More Awards";
    console.log("button >> ", button);
    console.log("showing >> ", showing);

    hiddenItems.forEach(function (item) {
      if (!showing) {
        item.classList.add("award-hidden");
      } else {
        item.classList.remove("award-hidden");
      }
      button.textContent =
        button.textContent === "More Awards" ? "Less Awards" : "More Awards";
    });
  };

  const selectRecentOnTop = (reportObject, awardObject) => {
    //console.log('selectRecentOnTop was called :: reportObject ', reportObject);
    //console.log('selectRecentOnTop was called :: awardObject ', awardObject);
    let checkReportInput = !!reportObject ? reportObject : [];
    let checkAwardInput = !!awardObject ? awardObject : [];

    if (checkReportInput.length + checkAwardInput.length > 0) {
      let maxYearReport = 0;
      let maxYearAward = 0;

      if (checkReportInput.length > 0) {
        let sortedReportByYear = checkReportInput.sort(function (a, b) {
          return Number(b.year) - Number(a.value);
        });
        let allReportYear = sortedReportByYear.map((repObj) => repObj.year);
        //console.log('All Report years :: ', allReportYear);
        maxYearReport = allReportYear.reduce(function (a, b) {
          return Math.max(a, b);
        }, -Infinity);
        //console.log('Max Report years :: ', maxYearReport);
      }
      if (checkAwardInput.length > 0) {
        let sortedAwarsByYear = checkAwardInput.sort(function (a, b) {
          return Number(b.year) - Number(a.value);
        });
        let allAwardYear = sortedAwarsByYear.map((repObj) => repObj.year);
        // console.log('All Award years :: ', allAwardYear);
        maxYearAward = allAwardYear.reduce(function (a, b) {
          return Math.max(a, b);
        }, -Infinity);
        //console.log('Max Award years :: ', maxYearAward);
      }

      if (maxYearAward > maxYearReport) {
        // console.log('maxYearAward > maxYearReport');
        return [...checkAwardInput, ...checkReportInput];
      }
      if (maxYearReport > maxYearAward) {
        //  console.log('maxYearReport > maxYearAward');
        return [...checkReportInput, ...checkAwardInput];
      }
      if (maxYearReport === maxYearAward) {
        //  console.log('maxYearReport === maxYearAward');
        return [...checkReportInput, ...checkAwardInput];
      }
    } else {
      return [];
    }
  };

  const getSVGClass = (classification) => {
    switch (classification.toLowerCase()) {
      case "customer excellence":
      case "top rated software":
      case "top 1000 b2b services":
      case "top 1000 b2b software":
      case "up-and-coming vendor":
        return `svg_logo svg_circle_award`;
      case "customers love us":
        return `svg_logo svg_penta_award`;
      case "hot 100 vendor":
      case "local leader":
      case "momentum leader":
        return `svg_logo svg_hex_award`;
      default:
        return `svg_logo`;
    }
  };

  return (
    <React.Fragment>
      {props.vendorProfile.awards.length + props.vendorProfile.reports.length >
      0 ? (
        <>
          <div className="award_block">
            <div className="award_list_block">
              <ul>
                {selectRecentOnTop(
                  [
                    ...props.vendorProfile.reports.map((report) => ({
                      ...report,
                      type: "report",
                    })),
                  ],
                  [
                    ...props.vendorProfile.awards.map((award) => ({
                      ...award,
                      type: "award",
                    })),
                  ]
                )
                  .slice(0, 2)
                  .map((award, index) => (
                    <li key={shortid.generate()}>
                      <div className="award" id={`svg_lg_${index}`}>
                        {setTimeout(() => {
                          getBadgeSVG(award, `svg_lg_${index}`);
                        }, 100)}
                      </div>
                      {getAwardDescription(award)}
                    </li>
                  ))}
                {props.vendorProfile.reports.length +
                  props.vendorProfile.awards.length >
                2 ? (
                  <li className="item award-hidden awardHide">
                    <ul>
                      {selectRecentOnTop(
                        [
                          ...props.vendorProfile.reports.map((report) => ({
                            ...report,
                            type: "report",
                          })),
                        ],
                        [
                          ...props.vendorProfile.awards.map((award) => ({
                            ...award,
                            type: "award",
                          })),
                        ]
                      )
                        .slice(2)
                        .map((award, index) => (
                          <li key={shortid.generate()}>
                            <div className="award" id={`svg_lg_${index + 2}`}>
                              {setTimeout(() => {
                                getBadgeSVG(award, `svg_lg_${index + 2}`);
                              }, 100)}
                            </div>
                            {getAwardDescription(award)}
                          </li>
                        ))}
                    </ul>
                  </li>
                ) : null}
              </ul>

              {props.vendorProfile.reports.length +
                props.vendorProfile.awards.length >
              2 ? (
                <span className="moreAwards">
                  <a
                    className="showLessMoreAward"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      hideShowContent(e);
                    }}
                  >
                    more awards
                  </a>
                </span>
              ) : null}
            </div>
          </div>
        </>
      ) : null}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    vendorProfile: state.vendorProfile,
    vendorCommon: state.vendorCommon,
  };
};

export default connect(mapStateToProps)(withRouter(SoftwareAward));
